import { initRedesignHeader } from "./redesignHeader.js";
// Only initialize redesign header if present
if (document.getElementById("secondary-nav")) {
  initRedesignHeader();
}
import React from "react";
import ReactDOM from "react-dom";

import { mobileNav } from "./mobileNav.js";
import { adjustHeight } from "./adjustHeight.js";
import { carousel } from "./carousel.js";
import { primaryNavigation } from "./primaryNavigation.js";

import { headerSearch } from "./headerSearch.js";
import { SearchPage } from "./search.jsx";
import { helpSearchTypeahead } from "./helpSearchTypeahead.js";

import { productFilters } from "./productFilters.js";
import { initSlider } from "./sliderInit.js";
import { imageComparisonInit } from "./imageComparison.js";

import { redesignAccordion } from "./redesignAccordion.js";
import { redesignInfoBar } from "./redesignInfoBar.js";
import { redesignImageAccordion } from "./redesignImageAccordion.js";
import { optionDrawer } from "./optionDrawer.js";
import { drawerFormSubmit } from "./drawerFormSubmit.js";
import { redesignTabbedAccordion } from "./redesignTabbedAccordion.js";
import { projectList } from "../views/components/redesign/projectList/projectList.js";
import { projectMap } from "../views/components/redesign/projectMap/projectMap.js";
import { olpLookup } from "./olpLookup.js";

const searchClass = document.querySelectorAll(".search-wrapper");

mobileNav();
adjustHeight();
carousel();
primaryNavigation();
headerSearch();
helpSearchTypeahead();
productFilters();

// Initialize Swiper slider(s)
initSlider();

// Initialize redesign accordion(s)
redesignAccordion();

// Initialize redesign info bar(s)
redesignInfoBar();

// Initialize redesign tabbed accordion(s)
redesignTabbedAccordion();

// Initialize redesign image accordion(s)
redesignImageAccordion();

// Initialize project list filter(s)
projectList();

// Initialize project map(s)
projectMap();

// Initialize OLP lookup
if (document.querySelector(".olp-lookup")) {
  olpLookup();
}

// Initialize option drawer(s)
if (document.querySelector(".redesign-option-drawer")) {
  optionDrawer();
}

// Initialize drawer form AJAX submission (event-delegated, runs once globally)
drawerFormSubmit();

// Initialize image comparison component(s)
document.querySelectorAll(".image-comparison-component").length &&
  imageComparisonInit();

if (searchClass.length > 0) {
  const root = ReactDOM.createRoot(document.getElementById("search-wrapper"));
  root.render(
    <SearchPage
      itemsPerPage={10}
      type=""
      data="https://dxp-au-search.funnelback.squiz.cloud/s/search.json"
    />,
  );
}

// Dynamically import the profileGrid module when needed.
var profileGridElement = document.getElementById("profile-grid");
if (profileGridElement) {
  import("./profileGrid.js?v=1.2")
    .then((module) => {
      // Execute the profileGrid function from the imported module
      module.profileGrid();
    })
    .catch((error) => {
      console.error("Failed to load the profileGrid module", error);
    });
}

// Dynamically import video reel when needed.
if (document.querySelector(".video-reel-swiper")) {
  import("./videoReelInit.js")
    .then((module) => module.videoReelInit())
    .catch((error) => console.error("Failed to load video reel init", error));
}

// Only load homepage banner video on desktop.
if (document.querySelector('.homepage-banner__video')) {
  import('./homepageBannerVideo.js')
    .then((module) => module.homepageBannerVideo())
    .catch((error) => console.error('Failed to load homepage banner video module', error));
}

// Dynamically import inline redesign video behavior when needed.
var inlineVideoElement = document.querySelector("[data-inline-video]");
if (inlineVideoElement) {
  import("./redesignInlineVideo.js")
    .then((module) => {
      module.redesignInlineVideo();
    })
    .catch((error) => {
      console.error("Failed to load the redesign inline video module", error);
    });
}

// Dynamically import the Video modal when needed.
var videoTriggerElement = document.querySelector(".video-image[data-video-id]");
var modalElement = document.getElementById("modal");
if (videoTriggerElement && modalElement) {
  import("./videoModal.js")
    .then((module) => {
      // Execute the profileGrid function from the imported module
      module.videoModal();
    })
    .catch((error) => {
      console.error("Failed to load the profileGrid module", error);
    });
}

document.addEventListener("livePreviewUpdated", () => {
  redesignAccordion();
  redesignInfoBar();
  redesignTabbedAccordion();
  redesignImageAccordion();
  projectList();
  projectMap();
  if (document.querySelector(".redesign-option-drawer")) optionDrawer();
  if (document.querySelectorAll(".image-comparison-component").length) imageComparisonInit();
});

//Auto add scroll feature to internal links that use a hash
const anchorLinks = document.querySelectorAll('a[href^="#"]');

anchorLinks.forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    // Get the href attribute value
    const href = this.getAttribute("href");

    // If the href is exactly "#", scroll to the top of the page
    // BUT skip this behavior for video triggers
    if (href === "#") {
      // Skip if this is a video trigger link
      if (
        this.classList.contains("video-image") ||
        this.hasAttribute("data-video-id")
      ) {
        return;
      }
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    // Find the target element on the page
    const targetElement = document.querySelector(href);
    if (targetElement) {
      e.preventDefault(); // Prevent the default jump-to behavior
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });
});
